import { TypedEmitter } from 'tiny-typed-emitter'
import { ExternalEvent } from './AppContext'

interface ExternalEventEmitterEvents {
    event: (data: ExternalEvent) => void
}

class ExternalEventEmitterClass extends TypedEmitter<ExternalEventEmitterEvents> {
    set(data: ExternalEvent) {
        if (data) {
            this.emit('event', data)
        }
    }
}

export const ExternalEventEmitter = new ExternalEventEmitterClass()
